export async function loadWebcam(width, height, fps) {
  if (!navigator.mediaDevices?.getUserMedia) {
    throw new Error('Browser API navigator.mediaDevices.getUserMedia is not available');
  }

  const video = document.getElementById('webcam');
  video.width = width;
  video.height = height;
  video.muted = true;

  const stream = await navigator.mediaDevices.getUserMedia({
    audio: false,
    video: {
      facingMode: 'user',
      width,
      height,
      frameRate: { max: fps },
    },
  });

  video.srcObject = stream;

  return new Promise((resolve) => {
    video.onloadedmetadata = () => resolve(video);
  });
}

export async function loadVideo(width, height, fps) {
  const video = await loadWebcam(width, height, fps);
  video.play();
  return video;
}
